<div class="container-fluid login-wrapper" style="height: 100vh;">
    <div class="row g-0 login-card shadow-lg" *ngIf="model.user_name != 'mwcc'">

        <!-- Left Panel -->
        <div class="col-lg-6 left-panel position-relative">

            <div class="overlay-content">

                <!-- Logo -->
                <div class="logo-area d-flex align-items-center mb-4">
                    <!--<div class="logo-icon me-3">
                        <i class="bi bi-mortarboard-fill"></i>
                    </div>
                    <div>
                        <h2 class="mb-0">Synergy</h2>
                        <p class="mb-0">Education ERP</p>
                    </div>-->
                    <img src="images/erp-logo.png" height=60>
                </div>

                <!-- Heading -->
                <h1 class="main-heading">
                    Smarter Education<br>
                    Stronger Institutions
                </h1>

                <div class="heading-line"></div>

                <p class="description-text">
                    SynergyERP provides an integrated and comprehensive platform to streamline 
                    the management of academics, administration, finance, and other institutional 
                    operations efficiently.
                </p>

                <!-- Features -->
                <div class="row feature-grid mt-4">

                    <div class="col-4 text-center mb-2">
                        <div class="feature-icon">
                            <i class="bi bi-mortarboard"></i>
                        </div>
                        <h6>Academics</h6>
                    </div>

                    <div class="col-4 text-center mb-2">
                        <div class="feature-icon">
                            <i class="bi bi-people"></i>
                        </div>
                        <h6>Admission</h6>
                    </div>

                    <div class="col-4 text-center mb-2">
                        <div class="feature-icon">
                            <i class="bi bi-clipboard-check"></i>
                        </div>
                        <h6>Attendance</h6>
                    </div>

                    <div class="col-4 text-center">
                        <div class="feature-icon">
                            <i class="bi bi-currency-rupee"></i>
                        </div>
                        <h6>Finance</h6>
                    </div>

                    <div class="col-4 text-center">
                        <div class="feature-icon">
                            <i class="bi bi-bar-chart"></i>
                        </div>
                        <h6>Reports</h6>
                    </div>

                    <div class="col-4 text-center">
                        <div class="feature-icon">
                            <i class="bi bi-gear"></i>
                        </div>
                        <h6>Settings</h6>
                    </div>

                </div>

            </div>
        </div>

        <!-- Right Panel -->
        <div class="col-lg-6 right-panel d-flex justify-content-center">
            <div class="login-box">
                <!-- <div class="text-end">
                    <input type="checkbox" id="searchToggle" class="search-toggle">
                    <div class="search-box-container">
                    <input type="text" name="keyCode" class="search-input-field" id="keyInput" 
                        placeholder="Enter ERP Key Code..." [(ngModel)]="erp_key4sub">      
                    <label for="searchToggle" class="search-text-btn btn btn-sm btn-outline-primary">
                        <span class="text-subscribe">Inst. Details</span>
                        <span class="text-proceed" (click)="proceed2subscribe()">Proceed!</span>
                    </label>
                    </div>
                </div> -->
                <!-- <div class="language-dropdown text-end">
                    <button class="btn btn-sm btn-outline-success border rounded-pill">
                        <i class="bi bi-currency-rupee"></i>
                        Subscribe!
                    </button>
                </div> -->

                <!-- User Icon -->
                <div class="text-center">
                    <!--<div class="user-circle mx-auto">
                        <i class="bi bi-person"></i>
                    </div>-->
                    <img src="images/erp-logo-main.png">
                </div>

                <!-- <h2 class="text-center fw-bold">Welcome Back!</h2> -->
                <p class="text-center text-muted mb-3 fw-semibold">
                    Sign in to your Synergy ERP account
                </p>

                <!-- Login Form -->
                <form class="mt-4" (ngSubmit)="submit()" #f="ngForm">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="col-6 form-group m-0 mb-2 position-relative" style="margin: auto;">
                            <i class="bi bi-building form-icon"></i>
                            <input type="text" name="erp_key" [(ngModel)]="model.erp_key" required class="form-control custom-input" 
                            placeholder="Enter ERP Key Code">
                        </div>
                        <div class="col-5 form-group m-0 mb-2 position-relative" style="margin: auto;">
                            <select class="form-select form-control custom-input" name="session" [(ngModel)]="model.session">
                                <option value="">--</option>
                                @for(fsn of fin_period; track fsn) {
                                    <option value="{{fsn.code}}">{{fsn.name}}</option>
                                }
                            </select>
                        </div>
                    </div>

                    <div class="form-group mb-2 position-relative">
                        <i class="bi bi-person form-icon"></i>
                        <input type="email" name="user_name" [(ngModel)]="model.user_name" required class="form-control custom-input" placeholder="Username">
                    </div>

                    <div class="form-group mb-2 position-relative">
                        <i class="bi bi-lock form-icon"></i>
                        <input type="password" name="password" [(ngModel)]="model.password" required class="form-control custom-input" placeholder="Password">
                        <!--<i class="bi bi-eye eye-icon"></i>-->
                    </div>

                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" [checked]="remember" id="remember">
                            <label class="form-check-label" for="remember">
                                Remember me
                            </label>
                        </div>

                        <!--<a href="#" class="forgot-link">Forgot Password?</a>-->
                    </div>
                    <!-- <div *ngIf="error" class="errorMsg">{{error}}</div> -->
                    <button type="submit" class="login-btn w-100 mb-3">
                        <i class="bi bi-box-arrow-in-right me-2"></i>
                        Sign In
                    </button>

                    <!--<div class="divider text-center">
                        <span>or</span>
                    </div>

                    <button type="button" class="btn google-btn w-100 mb-4">
                        <img src="images/Google__G__logo.svg" width="22" alt="Google">
                        Sign in with Google
                    </button>-->

                    <p class="text-center text-muted mt-0 mb-0">
                        Don’t have an account?
                        <a href="https://erp.macwill.net/contact.php" class="contact-link" target="_blank">Contact Admin</a>
                    </p>
                </form>

                <!-- Footer -->
                <div class="right_footer d-flex justify-content-between align-items-center">
                    <div>
                        <i class="bi bi-shield-check me-2"></i>
                        Secure • Reliable • Scalable
                    </div>
                </div>

            </div>

        </div>

    </div>
</div>
